import { useState, useRef, useEffect } from "react";

import { getUtilities } from "../../../../menu-items/utilities";

import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

// material-ui
import { useTheme } from "@mui/material/styles";
import {
  Avatar,
  Box,
  Button,
  Chip,
  ClickAwayListener,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Paper,
  Popper,
  Stack,
  Typography,
} from "@mui/material";

// third-party
import PerfectScrollbar from "react-perfect-scrollbar";

// project imports
import MainCard from "ui-component/cards/MainCard";
import Transitions from "ui-component/extended/Transitions";

// assets
import { IconDatabase, IconLock, IconLogout, IconSettings } from "@tabler/icons";
import { color } from "utils/color";
import { useTranslation } from "react-i18next";

// ==============================|| PROFILE MENU ||============================== //

const ProfileSection = ({ name, email, type }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const customization = useSelector((state) => state.customization);
  const navigate = useNavigate();

  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [open, setOpen] = useState(false);
  /**
   * anchorRef is used on different componets and specifying one type leads to other components throwing an error
   * */
  const anchorRef = useRef(null);

  const handleLogout = async () => {
    localStorage.clear();
    getUtilities(t);
    navigate("/");
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const handleListItemClick = (event, index, route = "") => {
    setSelectedIndex(index);
    handleClose(event);

    if (route && route !== "") {
      navigate(route);
    }
  };
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const prevOpen = useRef(open);
  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  const handleBackup = async () => {
    try {
      const password = window.prompt("Enter backup password");

      if (!password) return;

      const res = await fetch(`${process.env.REACT_APP_API_URL}backup`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${password}`,
        },
      });

      if (!res.ok) {
        alert("Invalid password");
        return;
      }

      const blob = await res.blob();

      const now = new Date();
      const timestamp = now.toISOString().replace("T", "_").replace(/:/g, "-").split(".")[0];

      const fileName = `tuwaiq-backup-${timestamp}.gz`;

      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;

      document.body.appendChild(a);
      a.click();

      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <Chip
        sx={{
          width: "100px",
          height: "48px",
          alignItems: "center",
          borderRadius: "27px",
          transition: "all .2s ease-in-out",
          borderColor: color.fg,
          backgroundColor: color.bg,
          color: color.fg,
          "&[aria-controls='menu-list-grow'], &:hover": {
            borderColor: color.bg,
            background: color.fg,
            color: color.bg,
            "& svg": {
              stroke: color.bg,
            },
          },
          "& .MuiChip-label": {
            lineHeight: 0,
          },
        }}
        icon={
          <Avatar
            sx={{
              display: "flex",
              justifyContent: "space between",
              ...theme.typography.mediumAvatar,
              // margin: "8px 0 8px 8px",
              cursor: "pointer",
              backgroundColor: color.fg,
              color: color.bg,
              "&:hover": {
                backgroundColor: color.bg,
                color: color.fg,
              },
            }}
            ref={anchorRef}
            aria-controls={open ? "menu-list-grow" : undefined}
            aria-haspopup="true"
          />
        }
        label={<IconSettings stroke={1.5} size="1.5rem" color={color.fg} />}
        variant="outlined"
        ref={anchorRef}
        aria-controls={open ? "menu-list-grow" : undefined}
        aria-haspopup="true"
        onClick={handleToggle}
      />

      <Popper
        placement="bottom-end"
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        popperOptions={{
          modifiers: [
            {
              name: "offset",
              options: { offset: [0, 14] },
            },
          ],
        }}
      >
        {({ TransitionProps }) => (
          <Transitions in={open} {...TransitionProps}>
            <Paper
              sx={{
                color: color.fg,
                borderRadius: "10px",
                overflow: "hidden",
                border: `1px solid ${color.bg}`,
              }}
            >
              <ClickAwayListener onClickAway={handleClose}>
                <MainCard
                  border={false}
                  elevation={16}
                  content={false}
                  boxShadow
                  shadow={theme.shadows[16]}
                  sx={{
                    color: color.fg,
                  }}
                >
                  <Box sx={{ p: 2 }}>
                    <Stack>
                      <Stack direction="row" spacing={1} alignItems="center">
                        <Typography variant="h4" color={color.bg}>
                          {t("common.welcomeBack")}
                        </Typography>
                        <Typography component="span" variant="h4" sx={{ fontWeight: 400 }}>
                          {name || (type === "Admin" && "Admin")}
                        </Typography>
                      </Stack>
                      <Typography component="span" variant="h4" sx={{ fontWeight: 400, mt: 1 }}>
                        {email}
                      </Typography>
                    </Stack>
                  </Box>

                  <PerfectScrollbar
                    style={{
                      height: "100%",
                      maxHeight: "calc(100vh - 250px)",
                      overflowX: "hidden",
                    }}
                  >
                    {/* 
                    {/* Change Password Button */}

                    <div className="changePassWordContainer">
                      <button
                        className="changePassWordBtn"
                        onClick={(event) => handleListItemClick(event, 3, "/change-password")}
                      >
                        <span className="changePassWordText" aria-hidden="true">
                          <IconLock stroke={1.5} size="1.3rem" color={color.fg} />
                        </span>

                        <span className="changePassWordText">{t("common.changePass")}</span>
                      </button>
                    </div>
                    <Box sx={{ pt: 2 }}>
                      {type === "Admin" && (
                        <div className="changePassWordContainer">
                          <button className="changePassWordBtn" onClick={handleBackup}>
                            <span className="changePassWordText" aria-hidden="true">
                              <IconDatabase stroke={1.5} size="1.3rem" color={color.fg} />
                            </span>

                            <span className="changePassWordText">{t("Common.backup")}</span>
                          </button>
                        </div>
                      )}
                    </Box>
                    <Box sx={{ p: 2 }}>
                      <List
                        component="nav"
                        sx={{
                          width: "100%",
                          maxWidth: 350,
                          minWidth: 300,
                          backgroundColor: color.bg,
                          borderRadius: "10px",
                          [theme.breakpoints.down("md")]: {
                            minWidth: "100%",
                          },
                          "& .MuiListItemButton-root": {
                            mt: 0.5,
                            color: color.fg,
                            paddingBlock: "0px",
                          },
                        }}
                      >
                        <ListItemButton
                          sx={{
                            borderRadius: `${customization.borderRadius}px`,
                            "&:hover": {
                              backgroundColor: "transparent", // removes hover background
                            },
                          }}
                          selected={selectedIndex === 4}
                          onClick={handleLogout}
                        >
                          <ListItemIcon>
                            <IconLogout stroke={1.5} size="1.3rem" color={color.fg} />
                          </ListItemIcon>
                          <ListItemText
                            primary={
                              <Typography variant="body2" color={color.fg}>
                                {t("common.logout")}
                              </Typography>
                            }
                          />
                        </ListItemButton>
                      </List>
                    </Box>
                  </PerfectScrollbar>
                </MainCard>
              </ClickAwayListener>
            </Paper>
          </Transitions>
        )}
      </Popper>
    </>
  );
};

export default ProfileSection;
